import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import settings from 'settings';
import REDUCER_KEY from 'reducers/reducer.keys';
import THEME_KEY from 'reducers/theme.keys';
import { convertToUtcDate, formatDateTime } from 'library/time';
import { AddTags, Inner } from 'components/Page';
import { list } from 'actions';
import config from './config';

const mapDispatchToProps = dispatch => ({
  loadTags(id) {
    return dispatch(list(
      REDUCER_KEY.themes.key,
      {
        page: 0,
        pageSize: settings.APP_CONFIG.dropListSize,
        filters: [{
          id: 'model',
          value: 'booking'
        }],
        sorted: [{
          id: 'model',
          desc: false
        }]
      }
    ))
      .then((response) => {
        const page = 0;
        const pageSize = settings.APP_CONFIG.dropListSize;
        const sorted = [{
          id: 'name',
          desc: false
        }];
        const filters = [
          {
            id: 'theme',
            value: response.results[0].id
          },
          {
            id: 'object_id',
            value: id
          }
        ];
        return dispatch(list(REDUCER_KEY.itemTags.key, {
          page,
          pageSize,
          filters,
          sorted
        }));
      });
  }
});

/*
 ** @description Prepare data for api
 ** @param props Object user, duration, type, status, start_datetime, end_datetime
 ** @return data object
 */
const handlePrepareData = ({
  arrival_date, arrival_time, departure_date, departure_time, reference_number, itinerary, leg, status
}) => ({
  reference_number,
  itinerary: itinerary.id ? itinerary.id : itinerary,
  status: status.label || status.name,
  leg_id: leg.key || leg.id,
  departure_date: formatDateTime(convertToUtcDate(departure_date.set({ // provide the time
    hour: departure_time ? departure_time.get('hour') : leg.departure_time.get('hour'),
    minute: departure_time ? departure_time.get('minute') : leg.departure_time.get('minute')
  })
    .format('YYYY-MM-DD HH:mm'))),
  arrival_date: formatDateTime(convertToUtcDate(arrival_date.set({ // provide the time
    hour: arrival_time ? arrival_time.get('hour') : leg.arrival_time.get('hour'),
    minute: arrival_time ? arrival_time.get('minute') : leg.arrival_time.get('minute')
  })
    .format('YYYY-MM-DD HH:mm')))
});

const TravelBookings = ({
  canAdmin, loadTags, objectId, onProcessTags, permissions
}) => {
  /*
   ** @description Do some post processing for the Tags
   ** @param data Object user, duration, type, status, start_datetime, end_datetime, tags
   ** @param
   ** @return data object
   */
  const handleSuccess = (response, data, original, callback) => {
    const { itemTags: tags } = data; // get the tags and object_id
    const { itemTags: originalTags } = original;
    const { id } = response; // the new or current id
    // only process valid records
    if (id > -1) {
      if (tags.length === 0 && originalTags.length === 0) {
        callback();
      }
      else {
        onProcessTags(THEME_KEY.booking, id, tags, originalTags)
          .finally(
            () => {
              callback(); // execute the succesfull callback
            }
          );
      }
    }
  };
  return (
    <Inner
      classes="bhp-travel-booking-detail"
      canAdmin={canAdmin && permissions.CanAdminTravel()
        .hasPermissions()}
      reducer={{
        parent: REDUCER_KEY.travelItineraries,
        item: REDUCER_KEY.travelBooking,
        list: REDUCER_KEY.travelBookings,
        extra: REDUCER_KEY.itemTags
      }}
      config={{
        ...config,
        list: {
          ...config.list,
          filters: {
            itinerary__id: [objectId]
          }
        },
        detail: {
          ...config.detail,
          parent: {
            itinerary: objectId
          }
        }
      }}
      defaultSize="420px"
      onLoadItem={loadTags}
      onPrepareData={handlePrepareData}
      onSuccessCallback={handleSuccess}
      scroll={{
        x: 800,
        y: '100%'
      }}
      messaging={{
        delete: {
          disabled: () => 'Item Disabled.',
          failure: error => `Delete Failed. ${error}`,
          success: () => 'Delete Successful.'
        },
        save: {
          failure: () => 'Saving failed',
          success: () => 'Saving was successful'
        }
      }}
      themeName="booking"
    />
  );
};

TravelBookings.propTypes = {
  canAdmin: PropTypes.bool,
  loadTags: PropTypes.func,
  objectId: PropTypes.number,
  onProcessTags: PropTypes.func,
  permissions: PropTypes.object.isRequired
};

TravelBookings.defaultProps = {
  canAdmin: true,
  objectId: null,
  loadTags() {
  },
  onProcessTags() {
  }
};

const Bookings = AddTags(TravelBookings);

export default connect(null, mapDispatchToProps)(Bookings);
